<template>
	<header
		class="header"
		style="min-height:100vh;margin-bottom:-40vh;"
		:style="{
			'background-image':
				'linear-gradient(rgba(0, 0, 0, 0.3), rgb(0, 0, 0)),url(' + bgImg + ')',
		}"
	>
		<div class="header__show-name textcontent">
			<h1>{{ item.items[0].name }}</h1>
			<h3>{{ item.items[0].description }}</h3>
			<div class="btn-cont">
				<div class="watchnow" @click="goToDetails(item.items[0])">
					Watch Now
				</div>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	name: "HeaderHome",
	props: ["catid"],
	beforeCreate() {
		this.$store.commit("setLoader", true);
		this.$store
			.dispatch("getCatalougeById", this.$store.state.globalconfigs.banner_id)
			.then((res) => {
				this.item = res._embedded;
				this.$store.commit("setLoader", false);
				this.bgImg = res._embedded.items[0].thumbnail.large;
				this.showbanner = true;
			})
			.catch((err) => {
				this.nocontent = true;
				this.$store.commit("setLoader", false);
			});
	},
	methods: {
		goToDetails(current) {
			var dynamicRoute = "/details/" + current.id + "/" + this.item._id;
			this.$router.push("" + dynamicRoute).then((res) => this.$router.go(0));
		},
	},
	data() {
		return {
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>

<style lang="scss">
.header {
	position: relative;
	height: 90vh;
	background-image: url("../assets/header-bg.png");
	background-size: cover;
	margin-bottom: -200px;
	&__show-name {
		position: absolute;
		display: flex;
		flex-direction: column;
		z-index: 99;
		top: 11vh;
		left: 3vw;
		text-align: left;
		color: white;
		p {
			width: 50%;
			font-weight: 100;
		}
		h3 {
			font-size: 1.5em;
		}
		h2 {
			font-weight: 100;
			align-self: flex-start;
			span {
				font-weight: bold;
			}
		}
		img {
			margin: 0;
			width: 500px;
		}
	}
	& > img {
		width: 70%;
		position: fixed;
		top: 0;
		right: 0;
	}
}
</style>

<style>
header {
}
.header__show-name {
	color: #fff;
	text-shadow: 1px 1px 5px #333;
}
.header__show-name h3 {
	width: 50%;
}
.textcontent .btn-cont {
	width: 50%;
	padding-top: 20px;
}
.textcontent .watchnow {
	padding: 10px;
	width: 40%;
	font-size: 1.2rem;
	border-radius: 3px;
	cursor: pointer;
	background: transparent;
	color: #fff;
	border: 1px solid #fff;
	text-align: center;
}
</style>
